"use client"

import { Navbar } from "@/components/navbar"
import { ThemeContext } from "@/context/ThemeContext"
import { useTheme as useThemeState } from "@/hooks/useTheme"
import React, { useEffect, useState } from "react"

type ThemeProviderProps = {
  children: React.ReactNode
}

export default function ThemeProvider({ children }: ThemeProviderProps) {
  // Use the useTheme hook to manage theme state
  const { themeSetting, activeTheme, toggleTheme, ...rest } = useThemeState()
  const [mounted, setMounted] = useState(false)

  // Handle mounted state separately to avoid hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])

  // Only render UI after mounting to avoid hydration mismatch
  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />
  }

  // Pass theme info to Navbar
  return (
    <ThemeContext.Provider
      value={{ themeSetting, activeTheme, toggleTheme, ...rest }}
    >
      <Navbar
        themeSetting={themeSetting}
        toggleTheme={toggleTheme}
      />
      <div className="relative z-10 transition-colors duration-500">
        {children}
      </div>
    </ThemeContext.Provider>
  )
}
